exports.linkResolver = (doc) => {
  
    if (doc.type === 'full_project' || 'partner' || 'person' || 'page') {
      return `/${doc.uid}`
    }
  
    // Backup for all other types
    return '/'
}